import { RAD_ACTION_KINDS as DOMAIN_RAD_ACTION_KINDS } from "@cadenza/rad-domain";

const RAD_ACTION_KINDS = new Set(DOMAIN_RAD_ACTION_KINDS);

const KIND_ALIASES = {
  externalEvent: "external_event",
  "external-event": "external_event",
  "case-refinement": "case",
  "part-refinement": "part",
  "part-repeat": "repeat",
};

const REFINEMENT_KINDS = new Set(["case", "part", "repeat", "refinement"]);

export const normalizeActivityKind = (value, fallback = "activity") => {
  if (typeof value !== "string" || value.trim() === "") return fallback;
  const mapped = KIND_ALIASES[value] || value;
  if (RAD_ACTION_KINDS.has(mapped)) return mapped;
  return fallback;
};

export const normalizeActivityForDomain = (activity = {}) => {
  const kind = normalizeActivityKind(activity.kind ?? activity.type ?? activity.shape_class);
  const inferredClass = REFINEMENT_KINDS.has(kind) ? "refinement" : "activity";
  return {
    ...activity,
    kind,
    type: kind,
    class: activity.class || activity.classname || inferredClass,
    classname: activity.classname || activity.class || inferredClass,
  };
};
